import { render, staticRenderFns } from "./PayIssue.vue?vue&type=template&id=b6882afa&scoped=true&"
import script from "./PayIssue.vue?vue&type=script&lang=js&"
export * from "./PayIssue.vue?vue&type=script&lang=js&"
import style0 from "./PayIssue.vue?vue&type=style&index=0&id=b6882afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6882afa",
  null
  
)

export default component.exports